


/**
* Participant Types within GuideStream
*/
export enum ParticipantType{
    /**
    * Mentor
    */
    Mentor = 0,
    /**
    * Internal Observer
    */
    Observer = 1,
    /**
    * Client (The Mentee)
    */
    Client = 2,
    /**
    * Guest
    */
    Guest = 3,
    /**
    * External Observer
    */
    ExternalObserver = 4
}

